/*
/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Day from './day';
import Month from './month';

class Calendar extends React.Component {
  constructor() {
    super();
    this.state = {
      start: moment(),
      end: moment().add(5, 'weeks'),
      monthView: false
    };
  }

  range = (start, end) =>
    new Array(end - start + 1)
      .fill(undefined)
      .map((value, index) => index + start);

  arrow = (direction, handleClick) => {
    const unit = this.state.monthView ? 'months' : 'weeks';

    return (
      <div className="btn" onClick={() => handleClick(direction, unit)}>
        <span
          className={`glyphicon glyphicon-triangle-${direction}`}
          aria-hidden="true"
        />
      </div>
    );
  };

  changeDate = (direction, unit) => {
    const { start } = this.state;
    let { monthView, end } = this.state;

    if (direction === 'top') {
      monthView = true;
      end = moment(start + moment.duration({ months: 34 }));
    } else if (direction === 'bottom') {
      monthView = false;
      end = moment(start + moment.duration({ weeks: 5 }));
    }
    if (direction === 'left') {
      start.add(-1, unit);
      end.add(-1, unit);
    } else if (direction === 'right') {
      start.add(1, unit);
      end.add(1, unit);
    }
    this.setState({ start, end, monthView });
  };

  renderDays = () => {
    const { start, end } = this.state;
    const { cadences } = this.props;
    const daysBetween = [...this.range(0, end.diff(start, 'days') - 1)];
    let startPoint = cadences.findIndex(
      cadence => moment(cadence.end_date) >= start
    );
    let checkCadence = startPoint > -1 && cadences[startPoint];
    let cadence = { state: '' };
    return daysBetween.map(day => {
      const date = start.clone().add(day, 'days');
      if (checkCadence) {
        const nextCadence = cadences[startPoint + 1] || {};
        const nextCadenceStart =
          nextCadence.start_date && date.isSame(nextCadence.start_date, 'day');
        checkCadence = date.isSameOrBefore(checkCadence.end_date, 'day')
          ? checkCadence
          : cadences[(startPoint += 1)];
        const useCadence =
          checkCadence &&
          date.isBetween(
            checkCadence.start_date,
            checkCadence.end_date,
            'day',
            '[]'
          );
        cadence = useCadence
          ? {
              start:
                date.isSame(checkCadence.start_date, 'day') ||
                date.isSame(start, 'day') ||
                nextCadenceStart,
              name: nextCadenceStart
                ? nextCadence.short_name
                : checkCadence.short_name,
              state: nextCadenceStart ? nextCadence.state : checkCadence.state
            }
          : { state: '' };
      }
      return <Day key={day} date={date} cadence={cadence} />;
    });
  };

  renderMonths = () => {
    const { start, end } = this.state;
    const { cadences } = this.props;
    const monthsBetween = [...this.range(0, end.diff(start, 'months'))];
    let startPoint = cadences.findIndex(
      cadence => moment(cadence.end_date) > start
    );
    let checkCadence = startPoint > -1 && cadences[startPoint];
    let cadence = { state: '' };

    return monthsBetween.map(month => {
      const date = start.clone().add(month, 'months');
      if (checkCadence) {
        const nextCadence = cadences[startPoint + 1] || {};
        const nextCadenceStart =
          nextCadence.start_date &&
          date.isSame(nextCadence.start_date, 'month');
        checkCadence = date.isSameOrBefore(checkCadence.end_date, 'month')
          ? checkCadence
          : cadences[(startPoint += 1)];
        const useCadence =
          checkCadence &&
          date.isBetween(
            checkCadence.start_date,
            checkCadence.end_date,
            'month',
            '[]'
          );
        cadence = useCadence
          ? {
              start:
                date.isSame(checkCadence.start_date, 'month') ||
                date.isSame(start, 'month') ||
                nextCadenceStart,
              name: nextCadenceStart
                ? nextCadence.short_name
                : checkCadence.short_name,
              state: nextCadenceStart ? nextCadence.state : checkCadence.state
            }
          : { state: '' };
      }
      return <Month key={month} date={date} cadence={cadence} />;
    });
  };

  render() {
    const direction = this.state.monthView ? 'bottom' : 'top';
    return (
      <div className="calendar-container">
        <div className="element">
          {this.arrow(direction, this.changeDate)}
          <br />
          {this.arrow('left', this.changeDate)}
        </div>
        <div className="calendar">
          {this.state.monthView ? this.renderMonths() : this.renderDays()}
        </div>
        <div className="element">
          {this.arrow(direction, this.changeDate)}
          <br />
          {this.arrow('right', this.changeDate)}
        </div>
      </div>
    );
  }
}

Calendar.propTypes = {
  cadences: PropTypes.array
};

export default Calendar;
